import React, { useState } from 'react';
import { getTernaryCondition } from 'common-ui-components/lib/core/utils/common';
import { get, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import HeaderComponent from 'common-ui-components/dist/components/Molecules/Header';
import {
  isUserLoggedIn,
  getRecentlySearchedItemsList,
  removeLastPartFromUrl,
  getBoolValue,
  getLocalCountryLanguage,
} from '../../../utils/utils';
import {
  getPageContextQuickOrderError,
  getPageContextCartItemAdded,
  getMyAccountUserName,
  getMyAccountDropdownUserName,
  getCartTotalItems,
} from './Header.utils';
import {
  signOutRequest,
  searchBarRequest,
  searchBarSubmit,
  searchBarInteraction,
  setEndSessionModalStatus,
} from '../../../global/actions';
import {
  SET_SIGN_IN_REDIRECT_KEY,
  EPROC_USER_ROLE,
  DISABLED,
  QUICK_ORDER_URL,
  PARTIAL_ENABLED,
  DEFAULT_PATH_FORMAT,
  PAGE_TO_DISABLE_FOOTER_SELECTOR,
} from '../../../global/constants';
import QuickOrderOverlay from './QuickOrderOverlay';
import { addItemToCart } from '../../templates/ShoppingCart/ShoppingCart.actions';
import Navigation from '../Navigation';
import RenderLogo from '../../../components/molecules/RenderLogo';
import { getOrCondition, endProcurementSession } from '../../../utils/utilFunctions';
import EndSessionModal from '../../../components/molecules/EndSesssionModal';

const getSwitchAccountUrl = (pageContext, switchAccountLink) =>
  pageContext === 'order' || pageContext === 'quote'
    ? switchAccountLink
    : `${switchAccountLink}?fromMenu=true`;

const isDisplayedOrderHistory = (displayedOrderHistoryLink, ordersLink) =>
  displayedOrderHistoryLink && !isEmpty(ordersLink);

// eslint-disable-next-line complexity
const Header = ({
  isCheckout,
  config,
  labels,
  userDetails,
  pageContent,
  signOutAction,
  openSwitchAccountModal,
  pageContext,
  cartLink,
  searchBarAction,
  suggestions,
  searchBarSubmit: searchBarSubmitQuery,
  countryCommerceConfig,
  isQuoteToOrder,
  isQuoteDisabled,
  showFaPiaoHistory,
  addToCart,
  shoppingCartDataError,
  quickOrderDataError,
  confirmationError,
  location,
  isCreateQuote,
  entries,
  isCartItemAdded,
  isQuickOrderCartItemAdded,
  isConfirmationCartItemAdded,
  isConfirmation,
  cartTotalItems,
  searchBarInteraction: searchBarInteractionQuery,
  endSessionModalStatus,
  setEndSessionModalAction,
  isCheckoutDisabled,
  isEProcurementApp,
  isEprocCountrySelectorEnabled,
}) => {
  const loginState = isUserLoggedIn();
  const headerContent = pageContent?.find(item => item.name === 'header') || {};
  const signInLink = get(headerContent, 'signInLink', '#');
  const signOutLink = get(headerContent, 'signOutLink', '#');
  const myAccountLink = get(headerContent, 'myAccountLink', '#');
  const profileLink = get(headerContent, 'profileLink', '#');
  const ordersLink = get(headerContent, 'ordersLink', '');
  const quoteLink = get(headerContent, 'quotesLink', '');
  const faPiaoLink = get(headerContent, 'faPiaosLink', '');
  const logoLink = get(headerContent, 'logoLink', '/');
  const profileLabel = get(labels, 'profile', '');
  const orderHistoryLabel = get(labels, 'orderHistory', '');
  const quoteHistoryLabel = get(labels, 'quoteHistory', '');
  const faPiaoHistoryLabel = get(labels, 'faPiaoHistory', '');
  const invoiceHistoryLabel = get(labels, 'invoiceHistory', '');
  const createAccountLabel = get(labels, 'createAccountLabel', '');
  const createAccountLink = get(headerContent, 'createAccountLink', '#');
  const switchAccountLabel = get(labels, 'switchAccountLabel', '');
  const switchAccountLink = get(headerContent, 'switchAccountLink', '#');
  const myAccount = get(labels, 'myAccount', '');
  const signIn = get(labels, 'signIn', '');
  const signOut = get(labels, 'signOut', '');
  const notRegistered = get(labels, 'notRegistered', '');
  const logoURL = get(headerContent, 'logo.fileReference', config.logoURL);
  const logoAltText = get(headerContent, 'logoAltText', '');
  const isoCode = get(userDetails, 'isoCode', '');
  const userRole = get(userDetails, 'userRole.role', '');
  const eProc = get(labels, 'eProc', false);
  const recentlySearched = getOrCondition(getRecentlySearchedItemsList(), []);
  const pathname = get(location, 'pathname', '');
  const soldTo = get(userDetails, ['soldTo'], []);
  const quickOrderUrl = `${removeLastPartFromUrl(pathname)}/${QUICK_ORDER_URL}`;
  const invoiceLink = get(headerContent, 'invoiceHistoryLink', '');
  const displayedOrderHistoryLink = getBoolValue(
    get(headerContent, 'displayedOrderHistoryLink', false)
  );
  const [hamburgerValue, setHamburgerValue] = useState(false);
  const CartDataError = getPageContextQuickOrderError({
    shoppingCartDataError,
    quickOrderDataError,
    confirmationError,
  });
  const isCartItemAddedStatus = getPageContextCartItemAdded({
    isCartItemAdded,
    isQuickOrderCartItemAdded,
    isConfirmationCartItemAdded,
  });
  const hamburgerClick = () => {
    setHamburgerValue(!hamburgerValue);
  };

  const getDisabledAndDistributerCountry = () => {
    let status = false;
    if (countryCommerceConfig === DISABLED) {
      status = true;
    }
    if (!loginState && countryCommerceConfig === PARTIAL_ENABLED) {
      status = true;
    }
    if (loginState && isEmpty(soldTo) && countryCommerceConfig === PARTIAL_ENABLED) {
      status = true;
    }
    return status;
  };
  const myAccountData = {
    label: getMyAccountUserName(),
    icon: config.userIcon,
    url: isCheckout ? '' : myAccountLink,
    id: 'myAccount',
    elementLocator: 'myAccount',
    disabled: false,
    name: getMyAccountDropdownUserName(),
  };
  const myAccountDataEproc = {
    label: myAccount,
    icon: config.userIcon,
    url: myAccountLink,
    id: 'myAccount',
    elementLocator: 'myAccount',
    disabled: false,
    name: getMyAccountDropdownUserName(),
  };
  const cartTotalItemsValue = getCartTotalItems(cartTotalItems, isConfirmation);
  const getMyaccountData = () => (eProc ? myAccountDataEproc : myAccountData);
  const isDisabledAndDistributerCountry = getDisabledAndDistributerCountry();
  const navItems = [
    ...[getMyaccountData()],
    ...(!isCheckout && !isCreateQuote && !isConfirmation && !isDisabledAndDistributerCountry
      ? [
          {
            label: labels.quickOrder,
            icon: config.addItemsToCart,
            url: quickOrderUrl,
            id: 'quickOrder',
            elementLocator: 'quick-order',
            name: labels.quickOrder,
          },
        ]
      : []),
    {
      label: labels.cart,
      icon: getTernaryCondition(
        isEmpty(cartTotalItemsValue),
        config.cartIcon,
        config.cartFilledIcon
      ),
      url: cartLink,
      id: 'cart',
      elementLocator: 'cart',
      disabled: countryCommerceConfig === DISABLED,
      name: labels.cart,
      cartTotalItems: cartTotalItemsValue,
    },
    ...(isCheckout
      ? []
      : [
          {
            label: '',
            icon: isEmpty(cartTotalItemsValue) ? config.cartIcon : config.cartFilledIcon,
            id: 'mobile',
            elementLocator: 'mobile-cart-icon',
            disabled: countryCommerceConfig === DISABLED,
            cartTotalItems: cartTotalItemsValue,
          },
        ]),
  ].filter(item => !isEmpty(item));
  const getFapiaoIsDisabled = () => !!(!showFaPiaoHistory || isEmpty(faPiaoLink));
  const getInvoiceIsDisabled = () => isEmpty(invoiceLink);
  const myAcountDropDown = {
    userIcon: config.userIcon,
    closeIcon: config.closeIcon,
    title: myAccount,
    notRegistered,
    myAccount: {
      text: myAccount,
      url: myAccountLink,
    },
    signIn: {
      text: signIn,
      url: signInLink,
    },
    signOut: {
      text: signOut,
      url: signOutLink,
    },
    switchAccount: {
      text: switchAccountLabel,
      url: isCheckout ? '#' : getSwitchAccountUrl(pageContext, switchAccountLink),
      onClick: isCheckout
        ? openSwitchAccountModal
        : () => {
            /* default openSwitchAccountModal handler */
          },
      isHidden: isQuoteToOrder,
    },
    createAccount: {
      text: createAccountLabel,
      url: createAccountLink,
    },
    itemList: isCheckout
      ? null
      : [
          {
            text: profileLabel,
            url: profileLink,
            isHiddenForEprocUser: false,
            isDisabled: false,
          },
          {
            text: orderHistoryLabel,
            url: ordersLink,
            isHiddenForEprocUser: true,
            isDisabled: getOrCondition(isEmpty(ordersLink), isCheckoutDisabled),
          },
          {
            text: quoteHistoryLabel,
            url: quoteLink,
            isHiddenForEprocUser: true,
            isDisabled: getOrCondition(isQuoteDisabled, isEmpty(quoteLink)),
          },
          {
            text: invoiceHistoryLabel,
            url: invoiceLink,
            isHiddenForEprocUser: true,
            isDisabled: getInvoiceIsDisabled(),
          },
          {
            text: faPiaoHistoryLabel,
            url: faPiaoLink,
            isHiddenForEprocUser: true,
            isDisabled: getFapiaoIsDisabled(),
          },
        ].filter(item => !(item.isHiddenForEprocUser && userRole === EPROC_USER_ROLE)),
    status: {
      full: 'FULL_ENABLED',
      partial: 'PARTIAL_ENABLED',
      disabled: 'DISABLED',
    },
  };

  const mobileV2Config = {};
  mobileV2Config.signOut = {
    text: signOut,
    url: signOutLink,
  };
  mobileV2Config.signIn = {
    text: signIn,
    url: signInLink,
  };
  mobileV2Config.loginState = loginState;
  mobileV2Config.homepageLink = signOutLink;
  mobileV2Config.signOutRequest = signOutAction;
  mobileV2Config.signInRedirectLink = SET_SIGN_IN_REDIRECT_KEY;

  const endSession = get(labels, 'endSession', '');
  const returnToEprocShort = get(labels, 'returnToEprocShort', '');
  const logoDirectoryPath = get(config, 'logoDirectoryPath', '');
  const removeAllItemsIconUrl = get(config, 'removeAllItemsIconUrl', '');
  const isDisplayedOrderHistoryLink = isDisplayedOrderHistory(
    displayedOrderHistoryLink,
    ordersLink
  );
  const openEndSessionModal = () => setEndSessionModalAction(true);
  const myAcountDropDownEproc = {
    userIcon: config.userIcon,
    closeIcon: config.closeIcon,
    title: myAccount,
    myAccount: {
      text: myAccount,
      url: '#',
    },
    switchAccount: {
      isHidden: true,
    },
    itemList: [
      {
        text: orderHistoryLabel,
        url: ordersLink,
        isDisabled: !isDisplayedOrderHistoryLink,
        class: 'dropdown__item-list__my-orders',
      },
      {
        text: invoiceHistoryLabel,
        url: invoiceLink,
        isDisabled: getInvoiceIsDisabled(),
        class: 'dropdown__item-list__my-invoices',
      },
      {
        text: endSession,
        url: '#',
        linkOnClick: openEndSessionModal,
        linkIcon: removeAllItemsIconUrl,
        textAfterLink: returnToEprocShort,
        isDisabled: false,
        isDisplayHrLine: true,
        class: 'dropdown__item-list__end-session',
      },
    ],
    ePRocMyAccount: true,
    logoDirectoryPath,
    logoDataLocator: 'my-account-dropdown-user-greeting-logo',
    renderCompanyLogo: RenderLogo,
  };

  const searchBarItems = {
    iconSearch: config.searchIcon,
    iconClear: config.closeIcon,
    searchPath: config.searchPath,
    multipleIconUrl: config.multipleIconUrl,
    placeholderDesktop: labels.searchPlaceholderDesktop,
    placeholderMobile: labels.searchPlaceholderTablet,
    onSearchRequest: searchBarAction,
    searchBarSubmit: searchBarSubmitQuery,
    searchBarInteraction: searchBarInteractionQuery,
    suggestions,
    recentlySearched,
    defaultConfig: {
      rows: config.searchDefaultRows,
      keyword: config.searchDefaultKeyword,
      mostRecent: config.searchDefaultmostRecent,
      mostRelevant: config.searchDefaultmostRelevant,
      isoCode,
    },
    labels: {
      clear: labels.clear,
      search: labels.search,
      searchBox: labels.searchBox,
      recentlySearched: labels.recentlySearched,
      all: labels.all,
      education: labels.education,
      events: labels.events,
      library: labels.library,
      support: labels.support,
      shop: labels.shop,
      aboutWaters: labels.aboutWaters,
      in: labels.in,
      viewAllLabel: labels.viewAllLabel,
      topResultsLabel: labels.topResultsLabel,
      partnumberLabel: labels.partnumberLabel,
    },
  };

  const getSearchBarItems = () => (isCheckout ? '' : searchBarItems);
  const myAccountConfig = {
    ...(eProc ? myAcountDropDownEproc : myAcountDropDown),
    loginState,
    userDetails,
    pageContent,
    signOutRequest: signOutAction,
    signInRedirectKey: SET_SIGN_IN_REDIRECT_KEY,
    searchBarItems: getSearchBarItems(),
    headerContent,
    isEProc: userRole === EPROC_USER_ROLE,
  };
  const { localeCountry, localeLanguage } = getLocalCountryLanguage();
  const countryLanguageProps = {
    headerContent,
    config,
    labels,
    localeCountry,
    localeLanguage,
    isEProc: userRole === EPROC_USER_ROLE,
    isEProcurementApp,
    defaultPathFormat: DEFAULT_PATH_FORMAT,
    disableFooterSelector: PAGE_TO_DISABLE_FOOTER_SELECTOR,
    isCheckout,
    isLanguageListJSON: isEProcurementApp && isEprocCountrySelectorEnabled,
  };
  const headerProps = {
    logo: { url: logoURL, name: logoAltText },
    navItems,
    myAccountConfig,
    hamburgerValue,
    logoLink,
    countryLanguageProps,
    hamburgerClick,
  };
  const navigationProps = {
    showDropdown: eProc,
    config,
    className: `${hamburgerValue ? ' is-active' : ''}`,
    labels,
    quickOrderUrl,
    isHideQuickOrderLink: getOrCondition(isConfirmation, isDisabledAndDistributerCountry),
    mobileV2Config,
  };
  return (
    <>
      <HeaderComponent {...headerProps}>
        <QuickOrderOverlay
          labels={labels}
          config={config}
          addToCart={addToCart}
          shoppingCartDataError={CartDataError}
          location={location}
          entries={entries}
          isCartItemAdded={isCartItemAddedStatus}
        />
      </HeaderComponent>
      {!isCheckout && <Navigation {...navigationProps} />}
      {eProc && (
        <EndSessionModal
          labels={labels}
          config={config}
          endProcurementSession={endProcurementSession}
          endSessionModalStatus={endSessionModalStatus}
          setEndSessionModalStatus={setEndSessionModalAction}
        />
      )}
    </>
  );
};

export const mapStateToProps = state => ({
  config: get(state, ['global', 'globalData', 'config'], {}),
  labels: get(state, ['global', 'globalData', 'labels'], {}),
  userDetails: get(state, ['global', 'globalData', 'userDetails'], {}),
  pageContent: get(state, ['global', 'globalData', 'pageData', 'Page Content', '_children'], []),
  cartLink: get(state, ['global', 'globalData', 'countryStatus', 'Page Content', 'viewCartUrl']),
  suggestions: get(state, ['global', 'globalData', 'searchResult'], {}),
  countryCommerceConfig: get(
    state,
    ['global', 'globalData', 'countryStatus', 'Page Content', 'countryCommerceConfig'],
    ''
  ),
  shoppingCartDataError: get(state, ['shoppingCart', 'shoppingCartData', 'error'], {}),
  quickOrderDataError: get(state, ['quickOrder', 'shoppingCartData', 'error'], {}),
  confirmationError: get(state, ['confirmation', 'shoppingCartData', 'error'], {}),
  location: get(state, ['global', 'globalData', 'route', 'location'], {}),
  entries: get(state, ['global', 'globalData', 'cart', 'entries'], []),
  isCartItemAdded: get(state, ['shoppingCart', 'shoppingCartData', 'isCartItemAdded'], false),
  isQuickOrderCartItemAdded: get(
    state,
    ['quickOrder', 'shoppingCartData', 'isCartItemAdded'],
    false
  ),
  isConfirmationCartItemAdded: get(
    state,
    ['confirmation', 'shoppingCartData', 'isCartItemAdded'],
    false
  ),
  cartTotalItems: get(state, ['global', 'globalData', 'cart', 'totalItems']),
  endSessionModalStatus: get(state, ['global', 'globalData', 'endSessionModalStatus'], false),
  isCheckoutDisabled: get(
    state,
    ['global', 'globalData', 'countryConfig', 'checkoutDisabled'],
    false
  ),
  isEProcurementApp: get(state, ['global', 'globalData', 'isEprocurementApp'], undefined),
  isEprocCountrySelectorEnabled: get(
    state,
    ['global', 'globalData', 'countryConfig', 'isEprocCountrySelectorEnabled'],
    false
  ),
});

export const mapDispatchToProps = dispatch => ({
  signOutAction: data => dispatch(signOutRequest(data)),
  searchBarAction: data => dispatch(searchBarRequest(data)),
  searchBarSubmit: data => dispatch(searchBarSubmit(data)),
  addToCart: (skuId, qty) => dispatch(addItemToCart(skuId, qty, true)),
  searchBarInteraction: data => dispatch(searchBarInteraction(data)),
  setEndSessionModalAction: data => dispatch(setEndSessionModalStatus(data)),
});

Header.propTypes = {
  config: PropTypes.shape({
    logoURL: PropTypes.string,
    logoName: PropTypes.string,
    searchIcon: PropTypes.string,
    userIcon: PropTypes.string,
    cartIcon: PropTypes.string,
    closeIcon: PropTypes.string,
    signInUrl: PropTypes.string,
    signOutUrl: PropTypes.string,
    myAccountLink: PropTypes.string,
    searchLink: PropTypes.string,
    cartLink: PropTypes.string,
    searchPath: PropTypes.string,
    searchDefaultRows: PropTypes.number,
    searchDefaultKeyword: PropTypes.string,
    searchDefaultmostRecent: PropTypes.string,
    searchDefaultmostRelevant: PropTypes.string,
    addItemsToCart: PropTypes.string,
    checkmarkIcon: PropTypes.string,
    continueShoppingUrl: PropTypes.string,
    multipleIconUrl: PropTypes.string,
    cartFilledIcon: PropTypes.string,
    removeAllItemsIconUrl: PropTypes.string,
    logoDirectoryPath: PropTypes.string,
  }),

  labels: PropTypes.shape({
    clear: PropTypes.string,
    search: PropTypes.string,
    searchBox: PropTypes.string,
    myAccount: PropTypes.string,
    cart: PropTypes.string,
    searchPlaceholderDesktop: PropTypes.string,
    searchPlaceholderTablet: PropTypes.string,
    recentlySearched: PropTypes.string,
    quickOrder: PropTypes.string,
    itemAddedToCart: PropTypes.string,
    viewCart: PropTypes.string,
    buttonContinueShopping: PropTypes.string,
    all: PropTypes.string,
    education: PropTypes.string,
    events: PropTypes.string,
    library: PropTypes.string,
    support: PropTypes.string,
    shop: PropTypes.string,
    aboutWaters: PropTypes.string,
    in: PropTypes.string,
    viewAllLabel: PropTypes.string,
    topResultsLabel: PropTypes.string,
    partnumberLabel: PropTypes.string,
    endSession: PropTypes.string,
    returnToEproc: PropTypes.string,
  }),
  userDetails: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.array, PropTypes.object])
  ),
  pageContent: PropTypes.arrayOf(PropTypes.string),
  isCheckout: PropTypes.bool,
  signOutAction: PropTypes.func,
  openSwitchAccountModal: PropTypes.func,
  pageContext: PropTypes.string,
  cartLink: PropTypes.string,
  searchBarAction: PropTypes.func,
  searchBarSubmit: PropTypes.func,
  suggestions: PropTypes.objectOf(PropTypes.string),
  countryCommerceConfig: PropTypes.string,
  isQuoteToOrder: PropTypes.bool,
  isQuoteDisabled: PropTypes.bool,
  showFaPiaoHistory: PropTypes.bool,
  addToCart: PropTypes.func,
  shoppingCartDataError: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.array, PropTypes.object])
  ),
  quickOrderDataError: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.array, PropTypes.object])
  ),
  confirmationError: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.array, PropTypes.object])
  ),
  location: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string])),
  isCreateQuote: PropTypes.bool,
  entries: PropTypes.arrayOf(PropTypes.string),
  isCartItemAdded: PropTypes.bool,
  isQuickOrderCartItemAdded: PropTypes.bool,
  isConfirmationCartItemAdded: PropTypes.bool,
  isConfirmation: PropTypes.bool,
  cartTotalItems: PropTypes.string,
  searchBarInteraction: PropTypes.func,
  endSessionModalStatus: PropTypes.bool,
  setEndSessionModalAction: PropTypes.func,
  isCheckoutDisabled: PropTypes.bool,
  isEprocCountrySelectorEnabled: PropTypes.bool,
  isEProcurementApp: PropTypes.bool,
};
Header.defaultProps = {
  config: {},
  labels: {},
  userDetails: {},
  pageContent: [],
  isCheckout: false,
  isQuoteToOrder: false,
  signOutAction: () => {
    /* default signOutAction handler */
  },
  openSwitchAccountModal: () => {
    /* default openSwitchAccountModal handler */
  },
  pageContext: '',
  cartLink: '',
  cartTotalItems: '',
  searchBarAction: () => {
    /* default searchBarAction handler */
  },
  searchBarSubmit: () => {
    /* default searchBarSubmit handler */
  },
  suggestions: {},
  countryCommerceConfig: '',
  isQuoteDisabled: false,
  showFaPiaoHistory: false,
  addToCart: () => {
    /* default addToCart handler */
  },
  shoppingCartDataError: {},
  quickOrderDataError: {},
  confirmationError: {},
  location: {},
  isCreateQuote: false,
  entries: [],
  isCartItemAdded: false,
  isQuickOrderCartItemAdded: false,
  isConfirmationCartItemAdded: false,
  isConfirmation: false,
  searchBarInteraction: () => {
    /* default search bar handler */
  },
  endSessionModalStatus: false,
  setEndSessionModalAction: () => {
    /* default setEndSessionModalStaus handler */
  },
  isCheckoutDisabled: false,
  isEProcurementApp: false,
  isEprocCountrySelectorEnabled: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);

export { Header };
